import $ from "jquery";
window.$ = window.jquery = $;
jQuery = $

import React, { useEffect, useState, } from "react";
// import "theia-sticky-sidebar";
// import {
// 	theomalaLogoHorizontalLarge,
// 	theomalaLogoHorizontalNavbar,
// 	vr_tour,
// 	new_vr_tour,
// } from "../../assets/img";
import theomalaLogoHorizontalLarge from '../../assets/img/theomala_logo_horizontal_large.png'
import vr_tour from '../../assets/img/vr-tour.png'
import new_vr_tour from '../../assets/img/new_vr_tour.png'
import { Link, NavLink, useHref, useParams } from "react-router-dom";
import Rooms from "../rooms";
import { useTranslation } from "react-i18next";


const Navbar = (props) => {
	const href = useHref();
	const [bannerData, setBannerData] = useState({})
  const {t, i18n} = useTranslation()

	useEffect(() => {
		if (href != "/")
			$(".fixed_header").addClass("sticky");
		else
			$(".fixed_header").removeClass("sticky");
	}, [href])

	$(window).on("scroll", function () {
		if (href == "/") {
			if ($(this).scrollTop() > 1)
				$(".fixed_header").addClass("sticky");
			else
				$(".fixed_header").removeClass("sticky");
		}
		else
			$(".fixed_header").addClass("sticky");
	});

	const handleSmoothScroll = () => {
		const handleSmoothScroll = (e) => {
			const link = e.target.closest('a.js-scroll-trigger[href*="#"]:not([href="#"])');
			if (!link) return;

			e.preventDefault();

			if (
				location.pathname.replace(/^\//, "") === link.pathname.replace(/^\//, "") &&
				location.hostname === link.hostname
			) {
				const target =
					document.querySelector(link.hash) ||
					document.querySelector(`[name=${link.hash.slice(1)}]`);

				if (target) {
					const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - 50;
					window.scrollTo({
						top: targetPosition,
						behavior: "smooth",
					});
				}
			}
		};

		document.addEventListener("click", handleSmoothScroll);

		// Cleanup function to remove the event listener
		return () => {
			document.removeEventListener("click", handleSmoothScroll);
		};
	};

	const menuOnClick = () => {
		$(".main-menu").toggleClass("show");
		$(".layer").toggleClass("layer-is-visible");
		// console.log("click");
	};

  const changeLanguage = async(lang) =>{
    i18n.changeLanguage(lang);
    await window.localStorage.setItem('lang', lang)
    location.reload()
  }

	useEffect(() => {
		window.$(document).ready(() => {
			jQuery(".fixed_title").theiaStickySidebar({
				minWidth: 991,
				additionalMarginTop: 120,
			});

			setInterval(async() => {
				var temp = await window.localStorage.getItem('bannerData')
				if(temp != null){
					temp = JSON.parse(temp)
					setBannerData(temp)
				}
			}, 1000)

			$('a[href^="#"].btn_scrollto').on("click", function (e) {
				e.preventDefault();
				var target = this.hash;
				var $target = $(target);
				$("html, body")
					.stop()
					.animate(
						{
							scrollTop: $target.offset().top - 60,
						},
						300,
						"swing",
						function () {
							window.location.hash = target;
						}
					);
			});

			handleSmoothScroll();

			// Close responsive menu when a scroll trigger link is clicked
			$(".js-scroll-trigger").click(function () {
				$(".nav_panel").toggleClass("show");
				$(".main-menu").toggleClass("show");
				$(".layer").toggleClass("layer-is-visible");
			});
		});
	}, []);

	return (
		<header className={"fixed_header menu_v1"}>
			<div className="layer"></div>
			<div className="container">
				<div className="row align-items-center" >
					<div className="col-md-3 col-5">
						<a href={"/"} className="logo_normal" aria-label="home link for normal navbar">
							<img
								src={theomalaLogoHorizontalLarge}
								width="100"
								height="34"
								alt="logo navbar"
								className="img-fluid"
								style={{ filter: "brightness(100)" }}
							/>
						</a>
						<a href={"/"} className="logo_sticky" aria-label="home link for sticky navbar">
							<img
								src={theomalaLogoHorizontalLarge}
								width="100"
								height="34"
								alt="logo navbar sticky"
								className="img-fluid"
							/>
						</a>
					</div>
					<div className="col-md-9 col-7" >
						<div className="main-menu">
							<a href="#0" className="closebt open_close_menu" onClick={menuOnClick} aria-label="close link on mobile">
								<i className="bi bi-x"></i>
							</a>
							<div className="logo_panel">
								<img src={theomalaLogoHorizontalLarge} width={180} alt="logo navbar" />
							</div>
							<nav id="mainNav">
								<ul>
									{/* <li>
										<a
											href="#about"
											className="js-scroll-trigger animated_link"
											onClick={menuOnClick}>
											About
										</a>
									</li> */}
									<li>
										<a href={"https://theomalatretes.com/virtual-tour/"} aria-label="virtual tour link" target="_blank" className={"js-scroll-trigger "}>
											<img src={vr_tour} alt="vr logo light" width={55} height={55} className="light-image"/>
											<img src={new_vr_tour} alt="vr logo dark" width={55} height={55} className="dark-image"/>
										</a>
									</li>
									<li>
										<a href={"/"} className={"js-scroll-trigger animated_link"} aria-label="home link">
                      {t('navbar.home')}
										</a>
									</li>
									<li>
										<a href={"/rooms"} className={"js-scroll-trigger animated_link"} aria-label="room link">
                      {t('navbar.rooms')}
										</a>
										{/* <a
                      href="#rooms"
                      className="js-scroll-trigger animated_link"
                      onClick={menuOnClick}
                    >
                      Rooms
                    </a> */}
									</li>
									<li>
										<a href={"/gallery"} className={"js-scroll-trigger animated_link"} aria-label="gallery link">
                      {t('navbar.gallery')}
										</a>
										{/* <a
                      href="#gallery"
                      className="js-scroll-trigger animated_link"
                      onClick={menuOnClick}
                    >
                      Gallery
                    </a> */}
									</li>
									{/* <li>
										<a
											href="#amenities"
											className="js-scroll-trigger animated_link"
											onClick={menuOnClick}>
											Activities
										</a>
									</li>
									<li>
										<a
											href="#contacts"
											className="js-scroll-trigger animated_link"
											onClick={menuOnClick}>
											Contacts
										</a>
									</li>
									<li>
										<a
											href="demos.html"
											className="js-scroll-trigger animated_link"
											onClick={menuOnClick}>
											Demos
										</a>
									</li> */}
									<li>
										<a href="https://www.e1-booking.com/widget?id=the-omala-hotel" target="_blank" className="js-scroll-trigger btn_1" aria-label="book button for book now">
										{/* <a href="#booking_section" className="js-scroll-trigger btn_1" aria-label="book button for book now"> */}
                      {t('navbar.bookNow')}
										</a>
									</li>
									<li>
										<div className="dropdown d-none d-lg-block">
											{/* <button
												className="js-scroll-trigger animated_link dropdown-toggle"
												type="button"
												data-bs-toggle="dropdown"
												aria-expanded="false">
												Dropdown button
                        EN
											</button> */}
                      <a href="#!" className="animated_link js-scroll-trigger" type="button"
												data-bs-toggle="dropdown"
												aria-expanded="false"
												aria-label="language link on mobile">
                        {localStorage.getItem('lang') != null ? localStorage.getItem('lang').toUpperCase() : 'id'}
                      </a>
											<ul className="dropdown-menu dropdown-menu-end" style={{minWidth: "unset"}}>
												{/* <li>
													<a className="dropdown-item active" href="#">
														Action
													</a>
												</li> */}
												<li className="m-0">
													<a className="dropdown-item text-black d-flex" href="#" onClick={() => changeLanguage("en")} aria-label="english link for language on desktop">
														EN
													</a>
												</li>
												<li className="m-0">
													<a className="dropdown-item d-flex text-black" href="#" onClick={() => changeLanguage("id")} aria-label="indonesia link for language on desktop">
														ID
													</a>
												</li>
												{/* <li>
													<hr className="dropdown-divider" />
												</li> */}
												{/* <li>
													<a className="dropdown-item" href="#">
														Separated link
													</a>
												</li> */}
											</ul>
										</div>
										<div className="d-flex d-lg-none align-items-center">
											<a href="#!" className={"animated_link m-0 " + (localStorage.getItem('lang') != null && localStorage.getItem('lang') == 'en' ? 'active' : '')} style={{ lineHeight: 1, }} type="button"
												data-bs-toggle="dropdown"
												aria-expanded="false"
												aria-label="english link for language on mobile"
												onClick={() => changeLanguage("en")}>
												EN
											</a>
											<p className="animated_link m-0" style={{ lineHeight: 1, }}>/</p>
											<a href="#!" className={"animated_link m-0 " + (localStorage.getItem('lang') != null && localStorage.getItem('lang') == 'id' ? 'active' : '')} style={{ lineHeight: 1, }} type="button"
												data-bs-toggle="dropdown"
												aria-expanded="false"
												aria-label="indonesia link for language on mobile"
												onClick={() => changeLanguage("id")}>
												ID
											</a>
										</div>
										{/* <a href="#" className="js-scroll-trigger ">
											EN
										</a> */}
									</li>
								</ul>
							</nav>
						</div>
						<div className="hamburger_2 open_close_menu float-end" onClick={menuOnClick}>
							<div className="hamburger__box">
								<div className="hamburger__inner"></div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</header>
	);
};

export default Navbar;
